<div class="vh_center mt-4">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
      <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
    </div>
  </div>
</div>
<section  class="container-fluid">
  <div class="text-center fa-2x mt-3"><b>Components Procurement</b></div>
  <div class="text-center row m-0">
    <div class="col-4"></div>
    <div class="col-4 p-2 mt-1">
      <div><b>BOM File: <span class="txt_dark_red">{{commonService.commonMainObj.uploadedFile?.name}}</span></b></div>
      <div><b>Quantity: <span class="txt_dark_red">{{commonService.commonMainObj.customQtyOfAssemblies}} Assemblies</span></b></div>
    </div>
    <div class="col-4"></div>
  </div>
  @if (commonService.commonMainObj.finalCustomBomPricingData?.okayToBuy != null && commonService.commonMainObj.finalCustomBomPricingData?.okayToBuy.length>0) {
    <div class="col-12">
      <div class="col-12 p-2 display-flex sierra_purchase_header">
        <div class="col-11"><span class="m-1 text-uppercase">Sierra will Purchase {{this.commonService.commonMainObj.finalCustomBomPricingData.okayToBuy?.length}} Part Numbers </span></div>
        <div class="col-1"><span class="bg-dark border-radius cursor-pointer p-1 text-white fs-14" (click)="showHidePurcData()">Show / Hide</span></div>
      </div>
      @if (showPurchaseData) {
        <div class="col-12 mb-3 justify-content-center" id="customQuoteBomTable-1">
          <div class="col-sm-12">
            <div class="table-responsive" id="customQuoteCppTableConatainer-1">
              <table width="100%" border="0" cellspacing="0" cellpadding="0" id="customQuoteCppTable1" class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 2%;"  align="center" valign="middle">ITEM#</th>
                    <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                    <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                    <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                    <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)({{commonService.commonMainObj.customQtyOfAssemblies}} Assemblies)</th>
                    <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                    <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                    <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                    <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                  </tr>
                </thead>
                <tbody id="display-tbody-okayTobuy">
                  @for (lit of commonService.commonMainObj.finalCustomBomPricingData?.okayToBuy; track lit; let in = $index) {
                    <tr>
                      <td align="center" valign="top">{{lit.itemNo}}</td>
                      <td align="center" valign="top">{{lit.mpn}}</td>
                      <td align="center" valign="top">{{lit.manufacturer}}</td>
                      <td align="center" valign="top">{{lit.qtyperBoard}}</td>
                      <td align="center" valign="top">{{lit.partDetail.pricingDetails[0].pricingInfo.buyQuantity}}</td>
                      <td align="center" valign="top">{{lit.alternateVendMpn}}</td>
                      <td align="center" valign="top">{{lit.refDes}}</td>
                      <td align="center" valign="top">{{lit.addedRemarks}}</td>
                      <td align="center" valign="top">
                        <select (change)="lineItemChange(lit.partDetail.pricingDetails[0].pricingInfo.selectedAction,lit,'okayToBuy','')" [(ngModel)]="lit.partDetail.pricingDetails[0].pricingInfo.selectedAction">
                          @for (actions of lit.partDetail.pricingDetails[0].pricingInfo.availableActions; track actions; let chIndx = $index) {
                            <option [value]="actions.actionId" [selected]="actions.actionId == lit.partDetail.pricingDetails[0].pricingInfo.selectedAction">{{actions.actionName}}</option>
                          }
                        </select>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (commonService.commonMainObj.finalCustomBomPricingData?.doNotInstall != null && commonService.commonMainObj.finalCustomBomPricingData?.doNotInstall.length>0) {
    <div class="col-12 mt-5">
      <div class="dni_header_table p-1">
        <span class="m-1"><b>DO NOT INSTALL(DNI)</b></span>
      </div>
      <div class="col-12 justify-content-center" id="ustomQuoteBomTable-2">
        <div class="col-sm-12">
          <div class="table-responsive" id="customQuoteCppTableConatainer-2">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" id="customQuoteCppTable2" class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 2%;"  align="center" valign="middle">ITEM#</th>
                  <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                  <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                  <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                  <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)({{commonService.commonMainObj.customQtyOfAssemblies}} Assemblies)</th>
                  <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                  <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                  <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                  <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                </tr>
              </thead>
              <tbody id="display-tbody-dni">
                @for (dniObj of commonService.commonMainObj.finalCustomBomPricingData?.doNotInstall; track dniObj; let in = $index) {
                  <tr>
                    <td align="center" valign="top">{{dniObj.itemNo}}</td>
                    <td align="center" valign="top">{{dniObj.mpn}}</td>
                    <td align="center" valign="top">{{dniObj.manufacturer}}</td>
                    <td align="center" valign="top">{{dniObj.qtyperBoard}}</td>
                    <td align="center" valign="top">{{dniObj.partDetail.pricingDetails[0].pricingInfo.buyQuantity}}</td>
                    <td align="center" valign="top">{{dniObj.alternateVendMpn?dniObj.alternateVendMpn:''}}</td>
                    <td align="center" valign="top">{{dniObj.refDes}}</td>
                    <td align="center" valign="top">{{dniObj.addedRemarks}}</td>
                    <td align="center" valign="top">
                      <select (change)="lineItemChange(dniObj.partDetail.pricingDetails[0].pricingInfo.selectedAction,dniObj,'doNotInstall',levelOneIssueModal)" [(ngModel)]="dniObj.partDetail.pricingDetails[0].pricingInfo.selectedAction">
                        @for (actions of dniObj.partDetail.pricingDetails[0].pricingInfo.availableActions; track actions; let chIndx = $index) {
                          <option [value]="actions.actionId" [selected]="actions.actionId == dniObj.partDetail.pricingDetails[0].pricingInfo.selectedAction">{{actions.actionName}}</option>
                        }
                      </select>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
  @if (commonService.commonMainObj.finalCustomBomPricingData?.iWillProvide != null && commonService.commonMainObj.finalCustomBomPricingData?.iWillProvide.length>0) {
    <div class="col-12 mt-5">
      <div class="customer_wil_consign p-1">
        <span class="m-1"><b>CUSTOMER WILL CONSIGN:</b></span>
      </div>
      <div class="col-12 justify-content-center" id="customQuoteBomTable-4">
        <div class="col-sm-12">
          <div class="table-responsive" id="customQuoteCppTableConatainer-4">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" id="customQuoteCppTable4" class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 2%;"  align="center" valign="middle">ITEM#</th>
                  <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                  <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                  <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                  <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)({{commonService.commonMainObj.customQtyOfAssemblies}} Assemblies)</th>
                  <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                  <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                  <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                  <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                </tr>
              </thead>
              <tbody id="display-tbody-dni">
                @for (custReqObj of commonService.commonMainObj.finalCustomBomPricingData?.iWillProvide; track custReqObj; let in = $index) {
                  <tr>
                    <td align="center" valign="top">{{custReqObj.itemNo}}</td>
                    <td align="center" valign="top">{{custReqObj.mpn}}</td>
                    <td align="center" valign="top">{{custReqObj.manufacturer}}</td>
                    <td align="center" valign="top">{{custReqObj.qtyperBoard}}</td>
                    <td align="center" valign="top">{{custReqObj.partDetail.pricingDetails[0].pricingInfo.buyQuantity}}</td>
                    <td align="center" valign="top">{{custReqObj.alternateVendMpn?custReqObj.alternateVendMpn:''}}</td>
                    <td align="center" valign="top">{{custReqObj.refDes}}</td>
                    <td align="center" valign="top">{{custReqObj.addedRemarks}}</td>
                    <td align="center" valign="top">
                      <select (change)="lineItemChange(custReqObj.partDetail.pricingDetails[0].pricingInfo.selectedAction,custReqObj,'iWillProvide','')" [(ngModel)]="custReqObj.partDetail.pricingDetails[0].pricingInfo.selectedAction">
                        @for (actions of custReqObj.partDetail.pricingDetails[0].pricingInfo.availableActions; track actions; let chIndx = $index) {
                          <option [value]="actions.actionId" [selected]="actions.actionId == custReqObj.partDetail.pricingDetails[0].pricingInfo.selectedAction">{{actions.actionName}}</option>
                        }
                      </select>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
  @if (commonService.commonMainObj.finalCustomBomPricingData?.customerSupport != null && commonService.commonMainObj.finalCustomBomPricingData?.customerSupport.length>0) {
    <div class="col-12 mt-5">
      <div class="customer_service_req p-1">
        <span class="m-1"><b>SIERRA CUSTOMER SERVICE REQUESTED on these parts:</b></span>
      </div>
      <div class="col-12 justify-content-center" id="customQuoteBomTable-3">
        <div class="col-sm-12">
          <div class="table-responsive" id="customQuoteCppTableConatainer-3">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" id="customQuoteCppTable3" class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 2%;"  align="center" valign="middle">ITEM#</th>
                  <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                  <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                  <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                  <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)({{commonService.commonMainObj.customQtyOfAssemblies}} Assemblies)</th>
                  <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                  <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                  <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                  <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                </tr>
              </thead>
              <tbody id="display-tbody-dni">
                @for (custObj of commonService.commonMainObj.finalCustomBomPricingData?.customerSupport; track custObj; let in = $index) {
                  <tr>
                    <td align="center" valign="top">{{custObj.itemNo}}</td>
                    <td align="center" valign="top">{{custObj.mpn}}</td>
                    <td align="center" valign="top">{{custObj.manufacturer}}</td>
                    <td align="center" valign="top">{{custObj.qtyperBoard}}</td>
                    <td align="center" valign="top">{{custObj.partDetail.pricingDetails[0].pricingInfo.buyQuantity}}</td>
                    <td align="center" valign="top">{{custObj.alternateVendMpn?custObj.alternateVendMpn:''}}</td>
                    <td align="center" valign="top">{{custObj.refDes}}</td>
                    <td align="center" valign="top">{{custObj.addedRemarks}}</td>
                    <td align="center" valign="top">
                      <select (change)="lineItemChange(custObj.partDetail.pricingDetails[0].pricingInfo.selectedAction,custObj,'customerSupport','')" [(ngModel)]="custObj.partDetail.pricingDetails[0].pricingInfo.selectedAction">
                        @for (actions of custObj.partDetail.pricingDetails[0].pricingInfo.availableActions; track actions; let chIndx = $index) {
                          <option [value]="actions.actionId" [selected]="actions.actionId == custObj.partDetail.pricingDetails[0].pricingInfo.selectedAction">{{actions.actionName}}</option>
                        }
                      </select>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
  @if (commonService.commonMainObj.finalCustomBomPricingData?.issueFound != null && commonService.commonMainObj.finalCustomBomPricingData?.issueFound.length>0) {
    <div class="col-12 mt-5">
      <div class="p-1 bg-red-section">
        <span class="m-1"><b> ISSUES FOUND:</b></span>
      </div>
      <div class="col-12 mb-3 justify-content-center" id="ustomQuoteBomTable-5">
        <div class="col-sm-12">
          <div class="table-responsive" id="customQuoteCppTableConatainer-5">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" id="customQuoteCppTable5" class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 2%;" align="center" valign="middle">ITEM#</th>
                  <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                  <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                  <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                  <th style="width: 9%;"  align="center" valign="middle">TOTAL QUANTITY (Including attrition)( {{commonService.commonMainObj.customQtyOfAssemblies}} Assemblies)</th>
                  <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                  <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                  <th style="width: 8%;" align="center" valign="middle">ISSUE</th>
                  <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                </tr>
              </thead>
              <tbody id="display-tbody-issues">
                @for (issuesObj of commonService.commonMainObj.finalCustomBomPricingData?.issueFound; track issuesObj; let in = $index) {
                  <tr>
                    <td align="center" valign="top">{{issuesObj.itemNo}}</td>
                    <td align="center" valign="top">{{issuesObj.mpn}}</td>
                    <td align="center" valign="top">{{issuesObj.manufacturer}}</td>
                    <td align="center" valign="top">{{issuesObj.qtyperBoard}}</td>
                    <td align="center" valign="top">{{issuesObj.partDetail.pricingDetails[0].pricingInfo.buyQuantity}}</td>
                    <td align="center" valign="top">{{issuesObj.alternateVendMpn}}</td>
                    <td align="center" valign="top">{{issuesObj.refDes}}</td>
                    <td align="center" valign="top">{{issuesObj.partDetail.pricingDetails[0].pricingInfo.issueName}}</td>
                    <td align="center" valign="top">
                      <button class="m-1 bg-orng_light text-white" (click)="resolveLineItem(resolve_item,issuesObj)">Resolve</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
  @if (commonService.commonMainObj.finalCustomBomPricingData.recommendations && commonService.commonMainObj.finalCustomBomPricingData?.recommendations?.length>0) {
    <div class="col-12 text-center">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5  m-3" data-mdb-toggle="button" autocomplete="off" id="sierraSugAlt" aria-pressed="true" (click)="sierraRecommandedAltsOnClick(alternateMpnModal)"> <b>Sierra Recommended Alternates</b></button>
      <button id="sierraSugAltInit" hidden (click)="sierraRecommandedAlts(alternateMpnModal)"></button>
      <div class="fs12 fw-semibold text-success">(Why? These parts are immediately available and have equal or better tolerance than your specified parts)</div>
    </div>
  }
  <div class="col-12 text-center">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Cancel</b>
  </button>
  @if (disableReqForCusQutBtn && commonService.commonMainObj.uploadedFile?.name) {
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="proceedToAdditionalComp()"> <b>Request for Custom Quote</b>
  </button>
}
@if (!disableReqForCusQutBtn && commonService.commonMainObj.uploadedFile?.name) {
  <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" disabled="true" (click)="proceedToAdditionalComp()"> <b>Request for Custom Quote</b>
</button>
}
</div>
<ng-template #resolve_item let-modal class="address-book-modal">
  <div class="modal-header">
    <div class="row col">
        <div class="col-11">
          <h4 class="modal-title" id="modal-basic-title"><span>Resolve Issue</span></h4>
        </div>
        <div class="col-1 text-right">
          <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="modal-crose">×</span>
          </button>
        </div>
      </div>
  </div>
  @if (resolveData) {
    <div class="modal-body">
      <div class="row mb-3 justify-content-center" id="budgetaryQuoteTableSec">
        <div class="col-sm-3"></div>
        <div class="col-sm-6">
          <div class="table-responsive" id="budgetaryQuoteTable">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
              <thead>
                <tr>
                  <th align="center" valign="middle">ITEM#</th>
                  <th align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                </tr>
              </thead>
              <tbody id="display-tbody-resol">
                <tr>
                  <td align="center" valign="top">{{selectedItemNumToResolve}}</td>
                  <td align="center" valign="top">{{selectedMpnToResolve}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-sm-3"></div>
      </div>
      <div class="mb-3">
        <div class="fw-bold">Issue: {{resolveDataSubHeaderIssueName}}</div>
      </div>
      <div class="mb-3">
        <div class="fw-bold">Choose Resolution:</div>
        @if (resolveData.substituteMpnList) {
          <div>
            <!-- <div class="fs12" *ngIf="resolveData.substituteMpnList && resolveData.substituteMPNList.length>0">{{resolveData.directMPNSubstitute[0]?.resolutionName}}</div> -->
            @if (resolveData.substituteMpnList) {
              <div>
                <div class="table-responsive" id="budgetaryQuoteTable">
                  <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                    <thead>
                      <tr>
                        <th align="center" valign="middle">Select</th>
                        <th align="center" valign="middle">MPN</th>
                        <th align="center" valign="middle">Part Number</th>
                        <th align="center" valign="middle">Quantity in Stock</th>
                      </tr>
                    </thead>
                    <tbody id="display-tbody-substitute">
                      @for (mpnSubStituteObj of resolveData.substituteMpnList; track mpnSubStituteObj) {
                        <tr>
                          <td align="center" valign="top"><input type="radio" name="resolvutionCheck" value="10" (click)="selectResol(mpnSubStituteObj,'10','')"/></td>
                          <td align="center" valign="top">{{mpnSubStituteObj.mpn}}</td>
                          <td align="center" valign="top">{{mpnSubStituteObj.digikeyPartNumber}}</td>
                          <td align="center" valign="top">{{mpnSubStituteObj.quantityAvailable}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
            @if (resolveData.substituteMpnList) {
              <div class="fw-bold fs-14">OR</div>
            }
          </div>
        }
        <div class="p-2">
          @for (resolObj of this.resolveModifiedValueMapObj | keyvalue; track resolObj) {
            <div ><span><input type="radio" name="resolvutionCheck" value="resolObj.key" (click)="selectResol('',resolObj.key,resolObj.value)"/> {{resolObj.value}}</span> </div>
          }
        </div>
      </div>
      @if (selectedResolName == 'Edit / fix the Manufacturer Part Number') {
        <div class="mb-3 justify-content-center">
          <div class="col-sm-12">
            <div class="table-responsive" id="resolve_issue_edit">
              <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                <thead>
                  <tr>
                    <th align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                    <th align="center" valign="middle">QUANTITY</th>
                    <th align="center" valign="middle">REFERENCE DESIGNATORS</th>
                  </tr>
                </thead>
                <tbody id="display-tbody-updateMpn">
                  <tr>
                    <td align="center" valign="top">
                      <input class="form-control" type="text" value="{{resolveDataDuplicate.mpn}}" [(ngModel)]="resolveDataDuplicate.mpn" required/>
                    </td>
                    <td align="center" valign="top">
                      <input class="form-control" type="text" value="{{resolveDataDuplicate.qtyperBoard}}" [(ngModel)]="resolveDataDuplicate.qtyperBoard" required/>
                    </td>
                    <td align="center" valign="top">
                      <input class="form-control" type="text" value="{{resolveDataDuplicate.refDes}}" [(ngModel)]="resolveDataDuplicate.refDes" required/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          @if (level1Errors.length > 0) {
            <div>
              @for (errorCheck of level1Errors ; track errorCheck; let indx = $index) {
                <div class="text-danger fs14">{{indx +1}}. {{errorCheck}}</div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="modal-footer text-center" style="display: block;">
    <!-- [disabled]="!selectedResolId" OFP-613 -->
    @if (resolveData) {
      <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="proceedWithResol()"><b>Proceed</b></button>
    }
    @if (conversionData) {
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')" ><b>Close</b></button>
    }
  </div>
</ng-template>
<ng-template #alternateMpnModal let-modal class="address-book-modal">
  
  <div class="modal-header">
    <!-- <h4 class="modal-title p-1" id="modal-basic-title">Sierra Recommended Alternates</h4>
    <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="modal-crose">×</span>
    </button> -->
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title p-1" id="modal-basic-title">Sierra Recommended Alternates</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="modal-crose">×</span>
      </button>
      </div>
    </div>
  </div>
  <div class="modal-body pt-0">
    <app-search-assist></app-search-assist>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5" (click)="selectedSierraSuggItems()"><b>Replace selected parts with Sierra Recommended Alternates</b></button>
  </div>
</ng-template>
<!-- LEVEL 1 ISSUES CHECK MODAL OFP-1717 -->
<ng-template #levelOneIssueModal let-modal class="address-book-modal">
  <div class="modal-header">
    <!-- <h4 class="modal-title p-1" id="modal-basic-title">BOM Item Issue Handling</h4> -->
     <div class="row col">
        <!-- <div class="col-11"> -->
          <h4 class="modal-title p-1" id="modal-basic-title">BOM Item Issue Handling</h4>
        <!-- </div> -->
      </div>
  </div>
  <div class="modal-body pt-0">
    @if (selectedDniItem) {
      <div class="col-12 mt-5">
        <div class="col-12 mb-3 justify-content-center" id="levelOneIssueCheckSec">
          <div class="col-sm-12">
            <div class="table-responsive" id="levelOneIssueCheckTable">
              <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 2%;" align="center" valign="middle">ITEM#</th>
                    <th style="width: 8%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                    <th style="width: 8%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                    <th style="width: 8%;" align="center" valign="middle">QUANTITY</th>
                    <th style="width: 18%;" align="center" valign="middle"> ISSUES FOUND </th>
                  </tr>
                </thead>
                <tbody id="display-tbody-issues">
                  <tr>
                    <td align="center" valign="top">{{selectedDniItem.itemNo}}</td>
                    <td align="center" valign="top" style="width: 200px;"><input class="form-control" type="text" id="dniIssueItemMpn" [(ngModel)]="selectedDniItem.mpn" placeholder="" /></td>
                    <td align="center" valign="top" style="width: 150px;"><input class="form-control" type="text" id="dniIssueItemRef" [(ngModel)]="selectedDniItem.refDes" placeholder="" /></td>
                    <td align="center" valign="top" style="width: 100px;"><input class="form-control" type="text" id="dniIssueItemQty" [(ngModel)]="selectedDniItem.qtyperBoard" placeholder="" /></td>
                    @if (selectedDniItem.errors) {
                      <td align="left" valign="top">
                        <ul style="text-align: left;">
                          @for (issuesObj of selectedDniItem.errors; track issuesObj; let in = $index) {
                            <li class="text-danger">{{issuesObj}}</li>
                          }
                        </ul>
                      </td>
                    }
                    @if (!selectedDniItem.errors) {
                      <td align="center" valign="top">None</td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <div class="fw-bold text-danger mb-2" id="errorMsg"> </div>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 btn-danger btn-red-custom" (click)="onCancel()"><b>Cancel</b></button>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5" (click)="dniItemIssueModalContinue(selectedDniItem)"><b>Continue</b></button>
    <!-- <div class="fw-bold text-success" *ngIf="!selectedDniItem.errors">All issues are resolved, Please wait while we move the component based on action selected</div> -->
  </div>
</ng-template>
</section>
